import React, { forwardRef } from 'react';
import styles from './CTAButton.module.css';
import { useCursor } from '@/contexts/CursorContext';

interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  ariaLabel?: string;
}

// Utilisation de forwardRef pour exposer la ref au parent
export const CTAButton = forwardRef<HTMLButtonElement, CTAButtonProps>(
  ({ children, onClick, className, ariaLabel, ...rest }, ref) => {
    const { setState } = useCursor();

    const onMouseEnter = () => {
      setState('link');
    };

    const onMouseLeave = () => {
      setState('default');
    };

    return (
      <button
        ref={ref}
        className={`${styles.ctaButton} ${className || ''}`}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
        aria-label={ariaLabel}
        {...rest}
      >
        <span className={styles.ctaButtonTextWrapper}>
          <span className={styles.ctaButtonText}>{children}</span>
          <span className={styles.ctaButtonText}>{children}</span>
        </span>
        <div className={styles.arrowIcon}>
          <svg
            width="14"
            height="11"
            viewBox="0 0 14 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.21234 0.213378C7.49686 -0.0711363 7.95815 -0.0711157 8.24268 0.213378L12.8797 4.84936C13.1642 5.13389 13.1642 5.59621 12.8797 5.88074L8.24268 10.5167C7.95815 10.8012 7.49686 10.8012 7.21234 10.5167C6.92795 10.2322 6.92789 9.77087 7.21234 9.48639L10.6053 6.09344L0 6.09344L0 4.63666L10.6053 4.63666L7.21234 1.24371C6.92789 0.959227 6.92795 0.497903 7.21234 0.213378Z"
              fill="#EA684D"
            />
          </svg>
        </div>
      </button>
    );
  }
);

CTAButton.displayName = 'CTAButton';
